import React from 'react'
import ExpensesForm from './ExpensesForm'
import './Expenses.css'
const Expenses = () => {
  return (
    <div className='expenses-container'>
      <ExpensesForm />
    </div>
  )
}

export default Expenses
